import axios from 'axios';
import { BASE_API_URL } from '../config/config';

export const api = axios.create({
    baseURL: BASE_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// ✅ REQUEST INTERCEPTOR (GLOBAL)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');

    // ✅ Attach token
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // ✅ 🔥 GLOBAL CACHE CONTROL
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';

 
    if (config.method === 'get') {
        config.params = {
            ...config.params,
            _t: new Date().getTime(), 
        };
    }

    return config;
});



// import axios from 'axios';
// import { BASE_API_URL } from '../config/config';
// import { store } from '../store';
// import { logout } from '../store/slices/authSlice';

// export const api = axios.create({
//     baseURL: BASE_API_URL,
//     headers: {
//         'Content-Type': 'application/json',
//     },
// });

// // Attach token to every request
// api.interceptors.request.use((config) => {
//     const token = sessionStorage.getItem('auth_token');
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
// });

// // Handle responses + session expiry
// api.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         const data = error?.response?.data;

//         if (
//             error?.response?.status === 401 &&
//             data?.error === 'SESSION_EXPIRED'
//         ) {
//             store.dispatch(logout());
//             window.location.href = '/login';
//         }

//         return Promise.reject(error);
//     }
// );
